<template>
  <div>
    <order-info :info="info" type="1" :list="infoList"/>
    <div class="form-container">
      <div class="el-descriptions-title">评价信息</div>
      <evaluative-info v-if="tableData.length" credit-round="1"
                       :supplier-type="$route.query.supplierType"
                       :table-data="applyItemPriceIdSet.length===1?[tableData[0]]:tableData"/>
      <evaluative-info v-if="applyItemPriceIdSet.length===1&&tableData.length>1" credit-round="2"
                       :supplier-type="$route.query.supplierType"
                       :table-data="[tableData[1]]"/>
    </div>
    <div v-if="!isDetails" class="form-container">
      <div class="el-descriptions-title">审核信息</div>
      <el-form style="width: 50%" :rules="rules" :model="form" label-width="95px" ref="form">
        <el-form-item label="审核结果：" prop="result">
          <el-radio-group v-model="form.result">
            <el-radio label="1">通过</el-radio>
            <el-radio label="2">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.result === '2'" label="驳回状态：" prop="retResult">
          <el-radio-group v-model="form.retResult">
            <el-radio label="1">现场审核</el-radio>
            <el-radio :disabled="disabled&&form.result === '2'" label="2">实物测试</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核意见：" prop="remark">
          <el-input v-model="form.remark" placeholder="请输入"
                    type="textarea" :maxlength="500" show-word-limit :rows="2">
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-container">
      <div class="el-descriptions-title">审核历史</div>
      <auditHistoryInfo type="2" :applyItemPriceIds="applyItemPriceIdSet"></auditHistoryInfo>
    </div>
    <div :style="{'text-align': isDetails?'left':'right'}">
      <eui-btn v-if="isDetails" type="secondary" @click="onCancel">返 回</eui-btn>
      <template v-else>
        <eui-btn type="secondary" @click="onCancel">取 消</eui-btn>
        <eui-btn type="primary" v-debounce="onSubmit">提 交</eui-btn>
      </template>
    </div>
  </div>
</template>

<script>
import auditHistoryInfo from '../ESapply/component/auditHistoryInfo.vue';
import orderInfo from '../components/orderInfo';
import evaluativeInfo from './components/evaluativeInfo';
import Api from '@/modules/projectA/api/ESorganization';
import bus from '@/components/common/bus';
import { reportAuditStatusList } from '../components/componentsData';

export default {
  components: { orderInfo, auditHistoryInfo, evaluativeInfo },
  data() {
    return {
      info: {
        evaluationCode: '',
        evaluateMethodName: '',
        className: '',
        auditStatus: ''
      },
      infoList: [
        { label: 'EQE编码', key: 'evaluationCode' },
        { label: '评价办法', key: 'evaluateMethodName' },
        { label: '审核状态', key: 'auditStatus' },
        { label: '产品类目', key: 'className' }
      ],
      form: {
        result: '1',
        retResult: '1',
        remark: ''
      },
      disabled: false,
      tableData: [],
      isDetails: this.$route.query.auditStatus !== '0',
      applyItemPriceId: '',
      applyItemPriceIdSet: []
    };
  },
  computed: {
    rules() {
      return {
        result: [{ required: true, message: '请选择' }],
        retResult: [{ required: this.form.result === '2', message: '请选择' }],
        remark: [{ required: this.form.result === '2', message: '请输入' }]
      };
    }
  },
  created() {
    const { allId } = this.$route.query;
    if (typeof allId === 'string') {
      this.applyItemPriceId = allId;
      this.applyItemPriceIdSet = [allId];
    } else {
      this.applyItemPriceId = allId[0];
      this.applyItemPriceIdSet = allId;
    }
    this.$set(this.info, 'auditStatus', reportAuditStatusList.find(item => item.id?.toString() === this.$route.query.auditStatus)?.name || '');
    this.getData();
  },
  methods: {
    /**
     * 获取基础信息
     */
    getData() {
      const { evaluationItemId, applyId } = this.$route.query;
      Api.leaderAuditDetail({
        // Api.getEvaluationApplyDetail({
        applyId,
        evaluationItemId,
        applyItemPriceIdSet: this.applyItemPriceIdSet
      }).then(res => {
        if (res.code === '200') {
          this.info = {
            ...this.info,
            ...res.data,
            ...res.data.evaluationApplyItemVO
          };
        }
      });
      // 待审核
      if (this.$route.query.auditStatus === '0') {
        Api.checkAuditLimit({
          applyId: this.$route.query.applyId,
          evaluationApplyItemPriceId: this.$route.query.id,
          evaluationItemId: this.$route.query.evaluationItemId
        }).then(res => {
          // 只能驳回到现场审查
          if (res.code === '200') {
            this.disabled = res.data === 1;
          }
        });
      }
      // 评价信息
      if (this.applyItemPriceIdSet.length === 1) {
        Api.queryReportAuditEvaluationInfo({
          supplierType: this.$route.query.supplierType,
          evaluationItemId: this.$route.query.evaluationItemId,
          id: this.$route.query.id
        }).then(res => {
          if (res.code === '200') {
            if (res.data.length) {
              let list = [];
              // 如果是复评，但是只有一条数据
              if (this.$route.query.creditRound !== '1' && res.data.length === 1) {
                list.push({
                  ...res.data[0],
                  productTest: '',
                  compositeScore: '',
                  grade: '',
                  testReportAttachPath: ''
                });
              }
              list = list.concat(res.data);
              this.tableData = list;
            }
          }
        });
      } else {
        // 合并评价信息
        Api.queryCoverEvaluationInfo({
          supplierType: this.$route.query.supplierType,
          itemPriceIdList: this.applyItemPriceIdSet
        }).then(res => {
          if (res.code === '200') {
            this.tableData = res.data;
          }
        });
      }
    },
    /**
     * 取消
     */
    onCancel() {
      bus.$emit('close_current_tags');
    },
    /**
     * 提交
     */
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交？', '易派客提醒您', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            const { applyId, allId, evaluationItemId } = this.$route.query;
            Api.leaderAudit({
              applyId,
              applyItemPriceIdSet: this.applyItemPriceIdSet,
              evaluationItemId,
              ...this.form,
              retResult: this.form.result === '2' ? this.form.retResult : undefined
            }).then(res => {
              if (res.code === '200') {
                this.$message.success('操作成功');
                this.onCancel();
              }
            });
          });
        }
      });
    }
  }
};
</script>


<style lang="scss" scoped>
  @import "../components/common";
</style>